import { render, staticRenderFns } from "./GrmSwitch.vue?vue&type=template&id=3dc7b39f&scoped=true&"
import script from "./GrmSwitch.vue?vue&type=script&lang=js&"
export * from "./GrmSwitch.vue?vue&type=script&lang=js&"
import style0 from "./GrmSwitch.vue?vue&type=style&index=0&id=3dc7b39f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7b39f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc7b39f')) {
      api.createRecord('3dc7b39f', component.options)
    } else {
      api.reload('3dc7b39f', component.options)
    }
    module.hot.accept("./GrmSwitch.vue?vue&type=template&id=3dc7b39f&scoped=true&", function () {
      api.rerender('3dc7b39f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/switch/GrmSwitch.vue"
export default component.exports